export default "__VITE_ASSET__00314e2c__"